import { mapMutations } from 'vuex';
import mixinActionBoxStyles from '@/components/core/mixinActionBoxStyles';
import get from 'lodash/get';
import overviewEditMixin from '@/components/core/dtwin/overviewEditMixin';
import EditMixin from '@/components/core/dtwin/editMixin';
import GeoDataMixin from '@/components/core/dtwin/geoDataMixin';
import { mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Dashboard from '@/views/dashboards/dashboard.vue';
import dashboardsService from '@/services/apiService/dashboards';
const defaultTab = ctx => {
  if (ctx.$route.query.stateId) {
    return 'tab-states';
  }
  if (ctx.$route.query.ruleId) {
    return 'tab-rules';
  }
  if (ctx.$route.query.dashboard !== undefined) {
    return 'tab-dashboard';
  }
  return 'tab-main';
};
export default {
  name: 'ViewDigitalTwinDigitalTwinDetails',
  components: {
    Dashboard
  },
  mixins: [EditMixin, GeoDataMixin, mixinActionBoxStyles, overviewEditMixin],
  data: function () {
    return {
      isLoadingDashboards: false,
      twinSelectionTreeMenu: true,
      pageYOffset: 0,
      tabItem: defaultTab(this),
      shouldOpenStateDetail: !!this.$route.query.stateId,
      dashboards: []
    };
  },
  computed: {
    ...mapState('app', ['uiTheme']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    }),
    headerBG() {
      if (get(this.twinObject, 'data.twinImageId')) {
        return `${location.origin}/api/v1/upload/${this.twinObject.data.twinImageId}`;
      }
      return null;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasDependentDevices() {
      return this.twinDependencies && this.twinDependencies.virtualDevices && this.twinDependencies.virtualDevices.length > 0;
    },
    dashboardId: {
      get() {
        return this.twinObject.dashboardId || '__DEFAULT__';
      },
      set(value) {
        if (value === '__DEFAULT__') {
          value = null;
        }
        const clone = cloneDeep(this.twinObject);
        clone.dashboardId = value;
        this.twinObject = clone;
      }
    },
    dashboardSelection() {
      const dashboardItems = this.dashboards.filter(dashboard => dashboard.identifier.tenantId === this.twinObject.tenantId).map(dashboard => ({
        id: dashboard.id,
        name: dashboard.meta.name
      }));
      dashboardItems.unshift({
        id: '__DEFAULT__',
        name: this.$i18n_t('DigitalTwin.DigitalTwin.dashboard.default')
      });
      return dashboardItems;
    }
  },
  watch: {
    twinDataStates() {
      if (this.twinDataStates.length) {
        if (this.shouldOpenStateDetail && this.$refs['stateTable']) {
          this.finishedLoadingStatesTable();
        }
      }
    },
    $route() {
      // the component is not reloaded/re-mounted if the twin-id in the route changes
      // so perform the setup again for a different route; i.e. swap out the displayed details on-the-fly
      this.teardownDtwinSocket();
      this.setup();
      if (get(this.$route, 'query.stateId')) {
        this.tabItem = 'tab-states';
      } else if (get(this.$route, 'query.ruleId')) {
        this.tabItem = 'tab-rules';
      }
    },
    'twinObject.tenantId': {
      handler() {
        this.fetchDashboards();
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.saveScrollOffset);
    this.setup();
  },
  destroyed() {
    window.removeEventListener('scroll', this.saveScrollOffset);
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    digitalTwinChanged(selection) {
      if (parseInt(selection.id) !== parseInt(this.$route.params.id)) {
        this.$router.push(`/digitaltwin-mgmt/${selection.id}`);
        this.twinSelectionTreeMenu = false;
      }
      this.twinSelectionTreeMenu = false;
    },
    breadCrumbsPath() {
      const ancestorList = this.ancestorList();
      if (ancestorList.length) {
        return ancestorList.map(a => {
          return {
            to: `/digitaltwin-mgmt/${a.id}`,
            text: a.title
          };
        });
      }
      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }];
    },
    saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    },
    finishedLoadingStatesTable() {
      if (this.$route.query.stateId) {
        this.$nextTick(() => {
          const state = this.twinDataStates.find(s => s.id === parseInt(this.$route.query.stateId));
          if (state) {
            this.shouldOpenStateDetail = false;
            this.$refs['stateTable'].editState(state);
          }
        });
      }
    },
    didUpdateStates() {
      this.refreshStates();
    },
    dialogDisable() {
      this.dtwinToggleState();
    },
    prepareSubmit() {
      this.handleSubmit();
    },
    async fetchDashboards() {
      try {
        this.isLoadingDashboards = true;
        // TODO: use pagination, search etc.
        // https://digimondo.atlassian.net/browse/RD-8375?atlOrigin=eyJpIjoiNzYzMTBjNjgxYTdjNDY3YTkwMmFmNjVlYTQyM2JkMjQiLCJwIjoiaiJ9
        const response = await dashboardsService.fetchAll({
          selectedAccountIds: [this.twinObject.tenantId]
        });
        this.dashboards = response.dashboards;
      } catch (error) {
        this.snackbar({
          text: this.$i18n_t('DigitalTwin.DigitalTwin.dashboard.errorFetchingDashboards'),
          color: 'error'
        });
      } finally {
        this.isLoadingDashboards = false;
      }
    }
  }
};